/**
 * Query-Keys der Plattform-Workspace-Verwaltung. Zentral gehalten, damit die Invalidation nach
 * Anlage und Statuswechsel konsistent bleibt.
 */
export const workspaceKeys = {
  all: ['workspaces'] as const,
  lists: () => [...workspaceKeys.all, 'list'] as const,
  list: (filters: object) => [...workspaceKeys.lists(), filters] as const,
};
